import { render, staticRenderFns } from "./MainDashboard.vue?vue&type=template&id=1b77afd6&scoped=true"
import script from "./MainDashboard.vue?vue&type=script&lang=ts"
export * from "./MainDashboard.vue?vue&type=script&lang=ts"
import style0 from "./MainDashboard.vue?vue&type=style&index=0&id=1b77afd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b77afd6",
  null
  
)

export default component.exports